import { Injectable } from '@angular/core';
import { gql } from 'apollo-angular';

import { ApiMutation } from '../../../../common/model/api.mutation';

export interface CreateUserModuleAnswersDocumentStatisticsInput {
	readonly questionId: string;
	readonly fieldId: string;
	readonly dataUrl: string;
}

export interface CreateUserModuleAnswersDocumentInput {
	readonly userId: string;
	readonly splitByRelationship: boolean;
	readonly organizationModuleId: string;
	readonly statistics: CreateUserModuleAnswersDocumentStatisticsInput[];
}

export interface CreateUserModuleAnswersDocumentParams {
	readonly input: CreateUserModuleAnswersDocumentInput;
}

@Injectable({ providedIn: 'root' })
export class CreateUserModuleAnswersDocumentApiMutation extends ApiMutation<
	boolean,
	CreateUserModuleAnswersDocumentParams
> {
	client = 'content';
	document = gql`
		mutation CreateUserModuleAnswersDocument(
			$input: CreateUserModuleAnswersDocumentInput!
		) {
			createUserModuleAnswersDocument(input: $input)
		}
	`;
	method = 'createUserModuleAnswersDocument';
}
